// extracted by mini-css-extract-plugin
module.exports = {"tabletMaxWidth":"1024px","tabletPortraitMaxWidth":"900px","phoneMaxWidth":"740px","phonePortraitMaxWidth":"420px"};